<script setup lang="ts">
import { cn } from '../utils'

const props = withDefaults(
    defineProps<{
        href?: string
        variant?: 'primary' | 'secondary'
    }>(),
    {
        variant: 'primary',
    }
)

const classes = cn(
    'inline-flex w-full items-center justify-center rounded-sm font-semibold px-3.5 py-2.5 focus-visible:outline-solid focus-visible:outline-2 focus-visible:outline-offset-2 disabled:cursor-not-allowed',
    {
        'bg-primary-800 text-white hover:bg-primary-700 focus-visible:outline-primary-800 disabled:bg-neutral-350':
            props.variant === 'primary',
        'bg-white text-primary-800 ring-1 ring-inset ring-neutral-300 hover:bg-neutral-50 disabled:hover:bg-white':
            props.variant === 'secondary',
    }
)
</script>

<template>
    <a v-if="href" :href="href" :class="classes">
        <slot />
    </a>
    <button v-else type="button" :class="classes">
        <slot />
    </button>
</template>
